import { Dispatch } from 'redux';

import { ActionType } from '../action-types';
import { GetAllTranslatorNotificationAction } from '../actions';
import { fbnApi as API } from '../../../../../../../utils/api-handler';

/*******************************************/
/*                                         */
/* GET ALL Translator NOTIFICATIONS API CREATOR */
/*                                         */
/*******************************************/

type GetAllTranslatorNotificationsRequestDataType = {
  userId: string;
  token: string;
  page: number;
  limit: number;
};

export const getAllTranslatorNotificationsList = ({
  userId,
  token,
  page,
  limit
}: GetAllTranslatorNotificationsRequestDataType) => {
  return async (dispatch: Dispatch<GetAllTranslatorNotificationAction>) => {
    dispatch({
      type: ActionType.GET_ALL_TRANSLATOR_NOTIFICATIONS_REQUEST
    });

    try {
      const response = await API(
        {
          data: '',
          method: 'GET',
          url: `/translator/notifications/${userId}` // ?page=${page}&perpage=${limit}`
        },
        token
      );
      dispatch({
        type: ActionType.GET_ALL_TRANSLATOR_NOTIFICATIONS_SUCCESS,
        payload: response
      });
    } catch (error) {
      dispatch({
        type: ActionType.GET_ALL_TRANSLATOR_NOTIFICATIONS_ERROR,
        payload: {
          data: [],
          statusCode: 400,
          message: 'Something went wrong. Please Try Again Later.'
        }
      });
    }
  };
};
